// extracted by mini-css-extract-plugin
module.exports = {"add-source-btn":"add-source-btn_2QHGQ","brand-component-display":"brand-component-display_3lOFL"};